import {
  FaCalendarAlt,
  FaReceipt,
  FaTools,
  FaCog,
  FaQuestionCircle,
  FaEnvelope,
  FaSignOutAlt,
} from 'react-icons/fa';

export const items = [
  {
    href: '/dashboard/planejamento',
    icon: FaCalendarAlt,
    title: 'components:nav.planning',
    disabled: false,
    menu: [
      {
        href: '/dashboard/planejamento/efetivo',
        title: 'components:nav.staff',
        disabled: false,
      },
      {
        href: '/dashboard/planejamento/meio-ambiente',
        title: 'components:nav.environment',
        disabled: true,
      },
      {
        href: '/dashboard/planejamento/estrutura',
        title: 'components:nav.structure',
        disabled: true,
      },
    ],
  },
  {
    href: '/dashboard/monitoramento',
    icon: FaTools,
    title: 'components:nav.monitoring',
    disabled: false,
    menu: [
      {
        href: '/dashboard/monitoramento',
        title: 'components:nav.home',
        disabled: false,
      },
      {
        href: '/dashboard/monitoramento/ordens-de-servico',
        title: 'components:nav.orders',
        disabled: false,
      },
      {
        href: '/dashboard/monitoramento/disponibilidade',
        title: 'components:nav.availability',
        disabled: false,
      },
      {
        href: '/dashboard/monitoramento/qualidade',
        title: 'components:nav.quality',
        disabled: true,
      },
    ],
  },
  {
    href: '/dashboard/analise',
    icon: FaReceipt,
    title: 'components:nav.analysis',
    disabled: false,
    menu: [
      {
        href: '/dashboard/analise/resultados',
        title: 'components:nav.results',
        disabled: false,
      },
    ],
  },
  {
    href: '/dashboard/configuracoes',
    icon: FaCog,
    title: 'components:nav.settings',
    disabled: false,
    menu: [
      {
        href: '/dashboard/configuracoes/perfil',
        title: 'components:nav.editProfile',
        disabled: false,
      },
    ],
  },
  {
    href: '/dashboard/central-de-ajuda',
    icon: FaQuestionCircle,
    title: 'components:nav.helpCenter',
    disabled: false,
    menu: [],
  },
  {
    href: '/dashboard/contato',
    icon: FaEnvelope,
    title: 'components:nav.contact',
    disabled: true,
    menu: [],
  },
  {
    href: '/dashboard/logout',
    icon: FaSignOutAlt,
    title: 'components:nav.logout',
    disabled: false,
    menu: [],
  },
];
